// extracted by mini-css-extract-plugin
module.exports = {"container":"_1vMVfv3v0Yyvxn4ncgJvPg","newSuggestedDishFields":"_2-XUrd29cPTxcC7mqbI0tQ"};